import React from "react";
import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react"
import Navigation from '../Navigation/Navigation';
import { useNavigate, useOutletContext } from 'react-router-dom';

function Payments() {
  const navigate = useNavigate();
  const { isAuthenticated, onLogOut } = useOutletContext();

  return (
    <Box bg="#F5F3F0" minH="100vh">
      <Navigation
        bg="#F5F3F0"
        onRouteChange={(route) => navigate(`/${route}`)}
        onLogOut={onLogOut}
        isAuthenticated={isAuthenticated}
      />
      <Container maxW="900px" px={8} py={12}>
        <VStack spacing={8}>
          <VStack spacing={2}>
            <Heading fontWeight="700" color="#1A1A1A" fontSize="2xl" letterSpacing="-0.02em">
              Choose your plan
            </Heading>
            <Text color="#52525B" fontSize="md">
              Upgrade to unlock unlimited AI generations and premium features.
            </Text>
          </VStack>
          <Box
            w="100%"
            bg="white"
            borderRadius="xl"
            border="1px solid"
            borderColor="#E4E4E7"
            boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
            p={8}
          >
            <stripe-pricing-table pricing-table-id="prctbl_1QEtqvGxTEV3NhLbybxnH1FY"
            publishable-key="pk_live_51QCJc5GxTEV3NhLbXWznVBfPJVZVNO2e5Ozm4G4nyFnlxZXEYlwZzkUiiDflCuV61ihImJ0Bv1E5JiibFdQuQrvU00kVHl502r">
            </stripe-pricing-table>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}



export default Payments
